import { appRoutes } from '@clearverify/constants';

import { LOGIN_REDIRECT_PARAM } from 'src/constants/auth';

// Same-origin path: single leading slash, then a non-slash/non-backslash char (or just '/').
// Rejects protocol-relative ('//evil.com'), backslash variants ('/\evil.com'), and external URLs —
// guards against open-redirect through the redirect param.
const SAFE_INTERNAL_PATH = /^\/(?:[^/\\].*)?$/;

const isSafeRedirect = (path: string | null | undefined): path is string => {
  return (
    !!path &&
    path !== appRoutes.root &&
    SAFE_INTERNAL_PATH.test(path) &&
    !path.startsWith(appRoutes.auth.index)
  );
};

export const withLoginRedirect = (
  basePath: string,
  redirect: string | null | undefined,
): string => {
  return isSafeRedirect(redirect)
    ? `${basePath}?${LOGIN_REDIRECT_PARAM}=${encodeURIComponent(redirect)}`
    : basePath;
};

export const resolveLoginRedirect = (redirect: string | null | undefined): string => {
  return isSafeRedirect(redirect) ? redirect : appRoutes.root;
};
